import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Eye } from "lucide-react";

/**
 * Live social proof — shows "X travelers viewed this stay in the last 24h".
 * Powered by the analytics_events collection (public cert page views + property views).
 */
export default function ViewersTicker({ propertyId }) {
  const [count, setCount] = useState(null);
  useEffect(() => {
    if (!propertyId) return;
    api.get(`/properties/${propertyId}/viewers`)
      .then((r) => setCount(r.data?.viewers_24h ?? 0))
      .catch(() => setCount(null));
  }, [propertyId]);
  if (count === null || count === 0) return null;
  return (
    <div
      data-testid="viewers-ticker"
      className="mt-4 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-50 border border-emerald-200 text-emerald-700 text-xs font-medium"
    >
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" />
      </span>
      <Eye className="w-3.5 h-3.5" />
      <span><b>{count}</b> travelers viewed this stay in the last 24h</span>
    </div>
  );
}
